import { RouterProvider, createBrowserRouter, Outlet } from 'react-router-dom';
import './css/app.css';
import MstUser, { loader as userLoader } from './views/Master/MstUser.jsx';
import MstRole from './views/Master/MstRole.jsx';
import MstLayout, { loader as masterLayoutLoader } from './views/Master/MstLayout.jsx';
import MstRackType from './views/Master/MstRackType.jsx';
import MstRackCategory from './views/Master/MstRackCategory.jsx';
import MstLocation from './views/Master/MstLocation.jsx';
import MstWarehouse, { loader as masterWarehouseLoader }  from './views/Master/MstWarehouse.jsx';
import MappingLayout, { loader as mappingLayoutLoader }from './views/Report/ReportMappingLayout.jsx';
import LandingPage from './views/LandingPage.jsx';
import ErrorPage from './views/Error';
import { authLoader } from './security/AuthorizeUser';
import { BlockUI } from './views/Utility.jsx';
import Login from './views/Login';
import Layout, { mapStateToProp } from './Layout';

import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';


import "./polyfills";
import { createRoot } from 'react-dom/client';

import * as serviceWorker from "./serviceWorker";
import "./assets/base.scss";
import configureAppStore from "./config/configureStore";
import { Provider } from "react-redux";

const store = configureAppStore();
const rootElement = document.getElementById("root");

const router = createBrowserRouter([
{ path: '/SignIn', element: <Login /> },
{
  path: '/',
  id: 'root',
  element: <Layout mapStateToProp={mapStateToProp} />,
  errorElement: <ErrorPage />,    
  loader: authLoader,
  HydrateFallback: BlockUI,
  children: [
    { index: true, element: <LandingPage />},
    { path: '/master/user', element: <MstUser />, loader: userLoader},
    { path: '/master/role', element: <MstRole />, loader: authLoader},
    { path: '/master/layout', element: <MstLayout />, loader: masterLayoutLoader},
    { path: '/master/racktype', element: <MstRackType /> },
    { path: '/master/rackcategory', element: <MstRackCategory /> },
    { path: '/master/location', element: <MstLocation /> },
    { path: '/master/warehouse', element: <MstWarehouse />, loader: masterWarehouseLoader},
    { path: '/report/mappinglayoutreport', element: <MappingLayout />, loader: mappingLayoutLoader},
  ],
},
],
{
  basename: '/',
});

const queryClient = new QueryClient();

const renderApp = () => (   
  //<React.StrictMode>
  <QueryClientProvider client={queryClient}>    
      <Provider store={store}>
        <RouterProvider router={router}>
        </RouterProvider>
    </Provider>
  </QueryClientProvider>
  //</React.StrictMode>
);

const root = createRoot(rootElement);
root.render(renderApp());

serviceWorker.unregister();